import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PresencaEscritorioApiService } from './api-presenca-escritorio.service';

@Injectable({
  providedIn: 'root'
})
export class PresencaEscritorioDataService {

  constructor(private api: PresencaEscritorioApiService) { }

  public GetPresenca(ano: number, mes: number): Observable<any> {
    return this.api.GetPresenca(ano, mes);
  }

  public RegistrarLocalizacao(latitude: number, longitude: number, precisaoMetros: number | null): Observable<any> {
    return this.api.RegistrarLocalizacao(latitude, longitude, precisaoMetros);
  }
}
